import Splide from '@splidejs/splide';
import flatpickr from "flatpickr";
import * as noUiSlider from "nouislider";

import { RVshare_search_response } from "./util/rvShareIntegration_typeDefs";
import { days_to_ms } from './util/general_util';

function handleOpen_rentalDropoffDatePicker(selectedDates: Array<Date>, dateStr: string, instance: any) {
    let sDate_inputEl:JQuery<HTMLElement> = $("#rvRental_sDate");
    let sDate_str:string|undefined;
    let sDate:Date;
    if (sDate_inputEl.length == 0) {
        return;
    };
    sDate_str = sDate_inputEl.val() as string;
    if (sDate_str == undefined) {
        return;
    };
    sDate = new Date(sDate_str);

    instance.setDate(new Date(sDate.getTime() + days_to_ms(2)));

};

function init_rentalDatePicker(sDate_inputEl:JQuery<HTMLElement>, eDate_inputEl:JQuery<HTMLElement>) {
    if (
        sDate_inputEl === null || sDate_inputEl === undefined || sDate_inputEl.length == 0
        || eDate_inputEl === null || eDate_inputEl === undefined || eDate_inputEl.length == 0
    ) return;
    let flatpickr_options:any = {
        mode: "single",
        altInput: true,
        altFormat: "m-d-Y",
        dateFormat: "Y-m-d",
        disableMobile: true,
        onChange: (selectedDates: Array<Date>, dateStr: string, instance: any) => {
            $("form#searchRVrentals").trigger("submit");
        }
    };
    window.rvRental_sDate_pickr = flatpickr(sDate_inputEl, flatpickr_options);
    flatpickr_options["onOpen"] = handleOpen_rentalDropoffDatePicker;
    window.rvRental_eDate_pickr = flatpickr(eDate_inputEl, flatpickr_options);
};

function init_slider(sliderEl:HTMLElement) {
    if (sliderEl === null || sliderEl === undefined) return;
    let rangeSlider:any = sliderEl.querySelector('.range-slider-ui'),
    valueMinInput:HTMLInputElement = sliderEl.querySelector('.range-slider-value-min'),
    valueMaxInput:HTMLInputElement = sliderEl.querySelector('.range-slider-value-max');
    let isPriceSlider:boolean;
    if (sliderEl.getAttribute("isPriceSlider") !== null) {
        isPriceSlider = true;
    } else {
        isPriceSlider = false;
    };
    let tooltipSuffix:string|null = sliderEl.getAttribute("data-tooltip-suffix");

    let options = {
        dataStartMin: parseFloat(sliderEl.dataset.startMin),
        dataStartMax: parseFloat(sliderEl.dataset.startMax),
        dataMin: parseFloat(sliderEl.dataset.min),
        dataMax: parseFloat(sliderEl.dataset.max),
        dataStep: parseFloat(sliderEl.dataset.step)
    };
    noUiSlider.create(rangeSlider, {
        start: [options.dataStartMin, options.dataStartMax],
        connect: true,
        step: options.dataStep,
        tooltips: true,
        range: {
            'min': options.dataMin,
            'max': options.dataMax
        },
        format: {
            to: function(value:number) {
                if (isPriceSlider) {
                    return "$" + value.toFixed(0)
                } else if (tooltipSuffix !== null) {
                    return value.toFixed(0) + tooltipSuffix;
                } else {
                    return value.toFixed(2);
                };
            },
            from: function(value:string) {
                return Number(value)
            }
        }
    });
    rangeSlider.noUiSlider.on('update', (values:any,handle:any) => {
        let value = values[handle];
        if (typeof(value) === "string") {
            value = value.replace(/[^\d^.]/g,'');
        };
        if (handle) {
            valueMaxInput.value = value;
        } else {
            valueMinInput.value = value;
        }
    });
    valueMinInput.addEventListener('change', function() {
        rangeSlider.noUiSlider.set([this.value, null]);
    });
    valueMaxInput.addEventListener('change', function() {
        rangeSlider.noUiSlider.set([null, this.value]);
    });
};

export function init_rentalFilters() {
    init_rentalDatePicker($("#rvRental_sDate"),$("#rvRental_eDate"));
    // init_slider(document.getElementById("rvRental_priceSlider"));
    // init_slider(document.getElementById("rvRental_lengthSlider"));

    $("#allDrivable").on("click", function() {
        $("input[type='checkbox'][name='rv_class'][drivable]").prop("checked",true);
    });
    $("#allTowable").on("click", function() {
        $("input[type='checkbox'][name='rv_class'][towable]").prop("checked",true);
    });
    $("#clearDrivable").on("click", function() {
        $("input[type='checkbox'][name='rv_class'][drivable]").prop("checked",false);
    });
    $("#clearTowable").on("click", function() {
        $("input[type='checkbox'][name='rv_class'][towable]").prop("checked",false);
    });

    $("#clearLength").on("click", function() {
        let sliderParent:HTMLElement = document.getElementById("rvRental_lengthSlider")
        let slider:any = sliderParent.querySelector('.range-slider-ui');
        slider.noUiSlider.set([sliderParent.getAttribute("data-start-min"),sliderParent.getAttribute("data-start-max")]);
    });
    $("#clearPrice").on("click", function() {
        let sliderParent:HTMLElement = document.getElementById("rvRental_priceSlider")
        let slider:any = sliderParent.querySelector('.range-slider-ui');
        slider.noUiSlider.set([sliderParent.getAttribute("data-start-min"),sliderParent.getAttribute("data-start-max")]);
    });
};

function sort_rental_cards(a:HTMLElement, b:HTMLElement, attr:string, inverse:boolean) {
    let scoreA:number,scoreB:number;
    let statsEl_a:JQuery<HTMLElement> = $(a).find("[stats]");
    let statsEl_b:JQuery<HTMLElement> = $(b).find("[stats]");

    if (statsEl_a.length == 0) {
        scoreA = 0
    } else {
        scoreA = parseInt(statsEl_a.attr(attr));
        if (Number.isNaN(scoreA)) scoreA = 0;
    };
    if (statsEl_b.length == 0) {
        scoreB = 0
    } else {
        scoreB = parseInt(statsEl_b.attr(attr));
        if (Number.isNaN(scoreB)) scoreB = 0;
    };
    if (inverse) return scoreA - scoreB
    else return scoreB - scoreA;
}

function init_rentalSortBy(sortByEl:JQuery<HTMLElement>) {
    const rvSearchForm:JQuery<HTMLElement> = $("form#searchRVrentals");
    sortByEl.on("change", function() {
        let sortBy:string = $(this).find(":selected").val().toString();
        rvSearchForm.find("input[name='sort_by']").val(sortBy);
        rvSearchForm.trigger("submit");
    });
};

export function init_splides(elms:JQuery<HTMLElement>) {
    for (let i:number = 0; i < elms.length; i++) {
        new Splide(elms[i]).mount().emit("resize");
    };
};

export function init_rentalResultsDisplay(resultsHTML:string, resultsWrapperEl:JQuery<HTMLElement>) {
    resultsWrapperEl.html(resultsHTML);
    let elms:JQuery<HTMLElement> = $("[rvRentalSplide]");
    init_splides(elms);
    init_rentalSortBy($("#sortBy_rvSearch"));

    $("[rvRental_getPage]").on("click", function() {
        const rvSearchForm:JQuery<HTMLElement> = $("form#searchRVrentals");
        rvSearchForm.attr("page", $(this).attr("page"));
        rvSearchForm.trigger("submit");
    });
    $("#searchRVrentals").attr("page",1);
    // $("#searchRVrentals").find("input[name='sort_by']").val(null);

    $("[view-rv-filters]").on("click", () => {
        $("#rvFiltersContainer").removeClass("d-none");
    });
};

export const rv_loc_search = async (lat:number,lng:number, extraArgs:string, page:number) => {
    let response:RVshare_search_response;
    let success:boolean = false;
    let errMsg:string;

    await $.ajax({
        type: "get",
        url: `/RVrentalSearch?lat=${lat}&lng=${lng}&page=${page}&${extraArgs}`,
        contentType: "application/x-www-form-urlencoded",
        dataType: "json",
        success: (data) => {
            success = true;
            response = data;
        },
		error: function(xhr,errStr,exc) {
			success = false;
			errMsg = errStr;
		}
    });

    return new Promise<RVshare_search_response>((resolve,reject) => {
        if (success) resolve(response);
        else reject(Error(errMsg));
    });
};